import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { PageTabs } from '@shared/components/page-tabs';
import { useEffect } from 'react';
import { generatePath, Outlet, useNavigate } from 'react-router-dom';
import { pcfRoutes } from '../pcf-routes';
import { useProductComponentTabs } from './tabs';

export default function ProductComponentsLayout() {
  const tabs = useProductComponentTabs();

  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to first tab if at base route
    if (window.location.pathname === pcfRoutes.PRODUCT_COMPONENTS) {
      navigate(tabs[0].href, { replace: true });
    }
  }, [navigate, tabs]);
  return (
    <Page name="Product Components" page="page" flexFullHeight>
      <PageHeader
        name="Components"
        includeBreadcrumb
        tabs={<PageTabs tabs={tabs} />}
        breadcrumbs={[
          {
            label: 'Products',
            url: generatePath(pcfRoutes.PRODUCTS),
          },
          {
            label: 'Components',
            url: generatePath(pcfRoutes.PRODUCT_COMPONENTS),
          },
        ]}
      />
      <Outlet />
    </Page>
  );
}
